import { render, staticRenderFns } from "./ParamTipoCusto.vue?vue&type=template&id=769c56e5"
import script from "./ParamTipoCusto.vue?vue&type=script&lang=js"
export * from "./ParamTipoCusto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports